var render = function render(){var _vm=this,_c=_vm._self._c;return _c('conteudo',{attrs:{"ajax":false}},[_c('div',{attrs:{"id":"equipesinscritas"}},[_c('h1',[_vm._v(" Equipes Inscritas ")]),_c('ajaxcontent',{attrs:{"url":_vm.getURL()}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }